import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Divider,
  LinearProgress,
  Grid,
  Button,
} from "@mui/material";
import { ArrowForward } from "@mui/icons-material";

const EnergyCard = ({
  title,
  power,
  savings,
  progress,
  panelSize,
  batterySize,
  upFrontCost,
  onClick,
}) => {
  return (
    <Card
      sx={{
        borderRadius: 2,
        m: 2,
        boxShadow: 3,
        width: { xs: "90%", md: "300px" },
        maxWidth: "100%",
      }}
    >
      <CardContent>
        <Typography variant="h6" align="center" gutterBottom>
          {title}
        </Typography>
        <Divider sx={{ my: 2 }} />

        <Grid container spacing={3}>
          <Grid item xs={6} align="center">
            <Typography variant="body2" color="textSecondary">
              Power
            </Typography>
            <Typography variant="h5">{power}</Typography>
            <Typography variant="body2">kWh/year</Typography>
          </Grid>
          <Grid item xs={6} align="center">
            <Typography variant="body2" color="textSecondary">
              Savings
            </Typography>
            <Typography variant="h5">{savings}</Typography>
            <Typography variant="body2">$/year</Typography>
          </Grid>
        </Grid>

        <Box sx={{ textAlign: "center", my: 2 }}>
          <Typography variant="body2" fontWeight="bold">
            Energy usage
          </Typography>
        </Box>

        <Grid container spacing={2} justifyContent="space-between">
          <Grid item>
            <Typography variant="body2" color="textSecondary">
              Consumers
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body2" color="textSecondary">
              Excess
            </Typography>
          </Grid>
        </Grid>

        <Box sx={{ my: 2 }}>
          <LinearProgress
            variant="determinate"
            value={progress * 100}
            sx={{ height: 20, borderRadius: 2 }}
          />
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="body2">
                {Number(progress * 100).toFixed(2)}%
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" color="textSecondary">
                {Number((1 - progress) * 100).toFixed(2)}%
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ my: 2 }}>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item>
              <Typography variant="body2" color="textSecondary">
                Panel Size
              </Typography>
              <Typography variant="body2">
                {Number(panelSize).toFixed(2)} kW
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" color="textSecondary">
                Battery Size
              </Typography>
              <Typography variant="body2">
                {Number(batterySize).toFixed(2)} kW
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            sx={{ mt: 2 }}
          >
            <Grid item>
              <Typography variant="body2" color="error">
                Upfront Cost
              </Typography>
              <Typography variant="body2" color="error">
                {Number(upFrontCost).toFixed(2)}$ (USD)
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Button
          variant="outlined"
          sx={{ width: "100%", mt: 2 }}
          endIcon={<ArrowForward />}
          onClick={() => {
            onClick();
          }}
        >
          More data
        </Button>
      </CardContent>
    </Card>
  );
};

export default EnergyCard;
